import $ from 'jquery';
import jQuery from 'jquery';
import { appconfig } from './config';
import { store } from './store';
import * as Actions from './actions';
import Logger from './helpers/logger';

function getConfig() {
    return appconfig();
}

$.postJSON = function (query, callback) {
    var config = getConfig();

    if (!config || !config.isConfigured) {
        if (callback) callback(undefined);
        window.location = '#/login';
        return;
    }

    var accessToken = store.getState().login.get('accessToken');
    var refreshToken = store.getState().login.get('refreshToken');

    var data = JSON.stringify({ query: query });

    return jQuery.ajax({
        type: 'POST',
        url: config.GQLurl,
        headers: { 'Authorization': 'Bearer ' + accessToken },
        contentType: 'application/json',
        data: data,
        dataType: 'json'
    })
        .done(response => {
            if (callback) callback(response);
        })
        .fail(response => {
            console.error('POST JSON FAIL:', response);
            Logger.log('POST JSON URL:', config.GQLurl);
            Logger.log('POST JSON QUERY:', query);

            if (response.status === 401 && refreshToken) {
                RefreshToken(refreshToken, (refreshResponse) => {
                    if (refreshResponse && refreshResponse.access_token) {
                        $.postJSON(query, callback);
                        return;
                    }

                    window.location = '#/login';
                });
                return;
            }

            if (response.status === 401 && !refreshToken) {
                window.location = '#/login';
                return;
            }

            if (callback) callback(response.responseJSON);
        });
};

export function RefreshToken(refreshToken, callback) {
    var config = appconfig();

    if (!config || !config.isConfigured) {
        store.dispatch(Actions.authenticationFailure());
        callback({});
        return;
    }

    store.dispatch(Actions.authenticationRequest());

    jQuery.ajax({
        type: 'POST',
        url: config.GQLserv + '/Token',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: $.param({
            grant_type: 'refresh_token',
            refresh_token: refreshToken,
            client_id: 'pmpos',
            client_secret: 'test'
        })
    }).done(response => {
        store.dispatch(Actions.authenticationSuccess(response.access_token, response.refresh_token));
        localStorage['access_token'] = response.access_token;
        localStorage['refresh_token'] = response.refresh_token;
        callback(response);
    }).fail(response => {
        store.dispatch(Actions.authenticationFailure());
        callback(response);
    });
}

export function Authenticate(userName, password, callback, failCallback) {
    var config = appconfig();

    if (!config || !config.isConfigured) {
        failCallback(0, 'GraphQL base url tanımlı değil.');
        return;
    }

    jQuery.ajax({
        type: 'POST',
        url: config.GQLserv + '/Token',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: $.param({
            grant_type: 'password',
            username: userName,
            password: password,
            client_id: 'pmpos',
            client_secret: 'test'
        })
    }).done(response => {
        callback(response.access_token, response.refresh_token);
    }).fail(response => {
        console.error('AJAX FAIL FULL:', response);
        Logger.log('STATUS:', response.status);
        Logger.log('STATUS TEXT:', response.statusText);
        Logger.log('RESPONSE TEXT:', response.responseText);

        var error = '';

        try {
            error = response.responseText
                ? JSON.parse(response.responseText).error_description
                : '';
        } catch (e) {
            error = response.responseText;
        }

        if (!error) {
            error = response.statusText;
        }

        failCallback(response.status, error);
    });
}

export function getTerminalTicket(terminalId, callback) {
    var query = getGetTerminalTicketScript(terminalId);
    $.postJSON(query, function (response) {
        if (response.errors) {
            if (callback) callback(undefined);
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function loadTerminalTicket(terminalId, ticketId, callback) {
    var query = getLoadTerminalTicketScript(terminalId, ticketId);
    $.postJSON(query, function (response) {
        if (response.errors) {
            if (callback) callback(undefined);
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function getTerminalTickets(terminalId, callback) {
    var query = getGetAllTerminalTicketsScript(terminalId);
    $.postJSON(query, function (response) {
        if (response.errors) {
            if (callback) callback(undefined);
        } else {
            if (callback) callback(response.data.tickets);
        }
    });
}

export function postRefresh() {
    var query = 'mutation m{postTicketRefreshMessage(id:0){id}}';
    $.postJSON(query);
}

export function getMenu(callback) {
    var query = getMenuScript();
    $.postJSON(query, function (response) {
        if (response.errors) {
            //handle
        } else {
            if (callback) callback(response.data.menu);
        }
    });
}

export function getProductPortions(productId, callback) {
    var query = getProductPortionsScript(productId);
    $.postJSON(query, function (response) {
        if (response.errors) {
            //handle
        } else {
            if (callback) callback(response.data.portions);
        }
    });
}

export function getProductOrderTags(productId, portion, callback) {
    var query = getProductOrderTagsScript(productId, portion);
    $.postJSON(query, function (response) {
        if (response.errors) {
            //handle
        } else {
            if (callback) callback(response.data.orderTags);
        }
    });
}

export function registerTerminal(callback) {
    var query = getRegisterTerminalScript();
    $.postJSON(query, function (response) {
        if (response.errors) {
            //handle
        } else {
            if (callback) callback(response.data.terminalId);
        }
    });
}

export function createTerminalTicket(terminalId, callback) {
    var query = getCreateTerminalTicketScript(terminalId);
    $.postJSON(query, function (response) {
        if (response.errors) {
            //handle
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function clearTerminalTicketOrders(terminalId, callback) {
    var query = getClearTerminalTicketScript(terminalId);
    $.postJSON(query, function (response) {
        if (response.errors) {
            //handle
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function closeTerminalTicket(terminalId, callback) {
    var query = getCloseTerminalTicketScript(terminalId);
    $.postJSON(query, function (response) {
        if (response.errors) {
            //handle
        } else {
            if (callback) callback(response.data.errorMessage);
        }
    });
}

export function getTerminalExists(terminalId, callback) {
    var query = getGetTerminalExistsScript(terminalId);
    $.postJSON(query, function (response) {
        if (response.errors) {
            //handle
        } else {
            if (callback) callback(response.data.result);
        }
    });
}

export function addOrderToTicket(ticket, productId, quantity = 1, callback) {
    var query = getAddOrderToTicketQuery(ticket, productId, quantity);
    $.postJSON(query, function (response) {
        if (response.errors) {
            // handle errors
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function addOrderToTerminalTicket(terminalId, productId, quantity = 1, orderTags = '', callback) {
    var query = getAddOrderToTerminalTicketScript(terminalId, productId, quantity, orderTags);
    $.postJSON(query, function (response) {
        if (response.errors) {
            // handle errors
            console.error('addOrderToTerminalTicket error', response.errors);
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function changeEntityOfTerminalTicket(terminalId, type, name, callback) {
    var query = getChangeEntityOfTerminalTicketScript(terminalId, type, name);

    $.postJSON(query, function (response) {
        if (response.errors) {
            // handle errors
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function getEntityScreenItems(name, callback) {
    var query = getGetEntityScreenItemsScript(name);
    $.postJSON(query, function (response) {
        if (response.errors) {
            // handle errors
        } else {
            if (callback) callback(response.data.items);
        }
    });
}

export function updateOrderPortionOfTerminalTicket(terminalId, orderUid, portion, callback) {
    var query = getUpdateOrderPortionOfTerminalTicketScript(terminalId, orderUid, portion);
    $.postJSON(query, function (response) {
        if (response.errors) {
            // handle errors
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function updateOrderQuantityOfTerminalTicket(terminalId, orderUid, quantity, callback) {
    var query = getUpdateOrderQuantityOfTerminalTicketScript(terminalId, orderUid, quantity);
    $.postJSON(query, function (response) {
        if (!response || response.errors) {
            if (callback) callback(undefined, response ? response.errors : undefined);
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function executeAutomationCommandForTerminalTicket(terminalId, orderUid, name, value, callback) {
    var query = getExecuteAutomationCommandForTerminalTicketScript(terminalId, orderUid, name, value);
    $.postJSON(query, function (response) {
        if (response.errors) {
            // handle errors
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function executeHesapYazForTerminalTicket(terminalId, orderUid, callback) {
    executeAutomationCommandForTerminalTicket(
        terminalId,
        orderUid,
        'Hesap Yaz',
        '',
        callback
    );
}

export function executeInposTSMForTerminalTicket(terminalId, orderUid, callback) {
    executeAutomationCommandForTerminalTicket(
        terminalId,
        orderUid,
        'Inpos TSM',
        '',
        callback
    );
}

export function updateOrderTagOfTerminalTicket(terminalId, orderUid, name, tag, callback) {
    var query = getUpdateOrderTagOfTerminalTicketScript(terminalId, orderUid, name, tag);

    $.postJSON(query, function (response) {
        if (response.errors) {
            console.error('updateOrderTagOfTerminalTicket errors', response.errors);
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function getOrderTagsForTerminal(terminalId, orderUid, callback) {
    var query = getGetOrderTagsForTerminalScript(terminalId, orderUid);
    $.postJSON(query, function (response) {
        if (response.errors) {
            callback([]);
        } else {
            if (callback) callback(response.data.orderTags);
        }
    });
}

export function getOrderTagColors(callback) {
    var query = getGetOrderTagColorsScript();
    $.postJSON(query, function (response) {
        if (response.errors) {
            // handle errors
        } else {
            if (callback) callback(response.data.colors);
        }
    });
}

export function cancelOrderOnTerminalTicket(terminalId, orderUid, callback) {
    var query = getCancelOrderOnTerminalTicketScript(terminalId, orderUid);
    $.postJSON(query, function (response) {
        if (response.errors) {
            // handle errors
        } else {
            if (callback) callback(response.data.ticket);
        }
    });
}

export function broadcastMessage(msg, callback) {
    var query = getPostBroadcastMessageScript(msg);
    $.postJSON(query, function (response) {
        if (response.errors) {
            // handle errors
        } else {
            if (callback) callback(response.data.postBroadcastMessage);
        }
    });
}

export function getCurrentUser(callback) {
    var pin = (localStorage['login_pin_code'] || '').trim();

    if (!pin) {
        console.warn('PIN bulunamadı');
        if (callback) callback(undefined);
        return;
    }

    var query = getGetUserScript(pin);

    $.postJSON(query, function (response) {
        if (!response || response.errors) {
            if (callback) callback(undefined);
        } else {
            if (callback) callback(response.data.user);
        }
    });
}

function getGetUserScript(pin) {
    var safePin = String(pin || '')
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"');

    return `query q{
        user:getUser(pin:"${safePin}") {
            name
            userRole {
                isAdmin
            }
        }
    }`;
}

function getMenuScript() {
    var config = getConfig();
    return `{menu:getMenu(name:"${config.menuName}"){categories{id,name,color,foreground,menuItems{id,name,color,caption,foreground,productId,defaultOrderTags,automationCommand}}}}`;
}
 
function getProductPortionsScript(productId) {
    return `{portions:getProductPortions(productId:${productId}){id,name,price}}`;
}

function getProductOrderTagsScript(productId, portion) {
    return `{orderTags:getOrderTagGroups(productId:${productId},portion:"${portion}",hidden:false){name,tags{name}}}`;
}

function getGetOrderTagsForTerminalScript(terminalId, orderUid) {
    return `
    mutation tags{orderTags:getOrderTagsForTerminalTicketOrder(
        terminalId:"${terminalId}"
	    orderUid:"${orderUid}")
    {name,tags{caption,color,labelColor,name,price}}}`;
}

function getRegisterTerminalScript() {
    var config = getConfig();
    return `mutation m{terminalId:registerTerminal(
        terminal:"${config.terminalName}",
        department:"${config.departmentName}",
        user:"${config.userName}",
        ticketType:"${config.ticketTypeName}")}`;
}

function getCreateTerminalTicketScript(terminalId) {
    return `mutation m{
            ticket:createTerminalTicket(terminalId:"${terminalId}")
        ${getTicketResult()}}`;
}

function getGetTerminalTicketScript(terminalId) {
    return `query q{
            ticket:getTerminalTicket(terminalId:"${terminalId}")
        ${getTicketResult()}}`;
}

function getLoadTerminalTicketScript(terminalId, ticketId) {
    return `mutation m{
            ticket:loadTerminalTicket(terminalId:"${terminalId}", ticketId:"${ticketId}")
        ${getTicketResult()}}`;
}

function getGetTerminalTicketsScript(terminalId) {
    return `query q{
            tickets:getTerminalTickets(terminalId:"${terminalId}")
        {id,date,lastOrderDate,remaining,number,entities{type,name}}}`;
}

function getGetAllTerminalTicketsScript(terminalId) {
    return `query q{
            tickets:getallTerminalTickets(terminalId:"${terminalId}")
        {id,date,lastOrderDate,remaining,number,entities{type,name}}}`;
}

function getGetAllTicketsScript(terminalId) {
    return `query q{
            tickets:getTickets
        {id,date,lastOrderDate,remaining,number,entities{type,name}}}`;
}

function getClearTerminalTicketScript(terminalId) {
    return `mutation m{
            ticket:clearTerminalTicketOrders(terminalId:"${terminalId}")
        ${getTicketResult()}}`;
}

function getUpdateOrderPortionOfTerminalTicketScript(terminalId, orderUid, portion) {
    return `mutation m {ticket:updateOrderOfTerminalTicket(
        terminalId:"${terminalId}",orderUid:"${orderUid}",portion:"${portion}")
    ${getTicketResult()}}`;
}

function getUpdateOrderQuantityOfTerminalTicketScript(terminalId, orderUid, quantity) {
    var safeQuantity = Number(quantity);

    if (isNaN(safeQuantity) || safeQuantity <= 0) {
        safeQuantity = 1;
    }

    return `mutation m {ticket:updateOrderOfTerminalTicket(
        terminalId:"${graphQlString(terminalId)}",
        orderUid:"${graphQlString(orderUid)}",
        quantity:${safeQuantity})
    ${getTicketResult()}}`;
}

function graphQlString(value) {
    return String(value || '')
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"');
}

function getUpdateOrderTagOfTerminalTicketScript(terminalId, orderUid, name, tag) {
    var tagName = name;
    var tagValue = tag;
    var quantity = 1;
    var price = 0;

    if (tag && typeof tag === 'object') {
        tagValue = tag.name || tag.tag || '';
        quantity = tag.quantity || 1;
        price = tag.price || 0;
    }

    var orderTagInput =
        `{tagName:"${graphQlString(tagName)}",` +
        `tag:"${graphQlString(tagValue)}",` +
        `quantity:${Number(quantity) || 1},` +
        `price:${Number(price) || 0}}`;

    return `mutation m{ticket:updateOrderOfTerminalTicket(
        terminalId:"${graphQlString(terminalId)}",
        orderUid:"${graphQlString(orderUid)}",
        orderTags:[${orderTagInput}])
    ${getTicketResult()}}`;
}

function getExecuteAutomationCommandForTerminalTicketScript(terminalId, orderUid, name, value) {
    return `mutation m{ticket:executeAutomationCommandForTerminalTicket(
        terminalId:"${terminalId}",
        orderUid:"${orderUid}",
	    name:"${name}",
        value:"${value}")
    ${getTicketResult()}}`;
}

function getCancelOrderOnTerminalTicketScript(terminalId, orderUid) {
    return `mutation m{ticket:cancelOrderOnTerminalTicket(terminalId:"${terminalId}",orderUid:"${orderUid}")
    ${getTicketResult()}}`;
}

function getCloseTerminalTicketScript(terminalId) {
    return `mutation m{
            errorMessage:closeTerminalTicket(terminalId:"${terminalId}")}`;
}

function getGetTerminalExistsScript(terminalId) {
    return `query q{
            result:getTerminalExists(terminalId:"${terminalId}")}`;
}

function getAddOrderToTerminalTicketScript(terminalId, productId, quantity = 1, orderTags = '') {
    var safeQuantity = Number(quantity);

    if (isNaN(safeQuantity) || safeQuantity <= 0) {
        safeQuantity = 1;
    }

    return `mutation m{
            ticket:addOrderToTerminalTicket(terminalId:"${terminalId}",
            productId:${productId}
            quantity:${safeQuantity}
            orderTags:"${orderTags}")
        ${getTicketResult()}}`;
}

function getChangeEntityOfTerminalTicketScript(terminalId, type, name) {
    return `mutation m{
            ticket:changeEntityOfTerminalTicket(terminalId:"${terminalId}",
            type:"Masalar"
            name:"${name}")
        ${getTicketResult()}}`;
}

function getGetEntityScreenItemsScript(name) {
    return `query q{items:getEntityScreenItems(name:"${name}"){name,caption,color,labelColor}}`;
}

function getGetOrderTagColorsScript() {
    return '{colors:getOrderTagColors{name,value}}';
}

function getTicketResult() {
    return `{id,uid,type,number,date,totalAmount,remainingAmount,
  entities{name,type},      
  states{stateName,state},
  tags{tagName,tag},
	orders{
    id,
    uid,
    productId,
    name,
    quantity,
    portion,
    price,
    priceTag,
    calculatePrice,
    increaseInventory,
    decreaseInventory,
    locked,
    taxes,
    tags{
      tag,tagName,price,quantity,rate,userId
    },
    states{
      stateName,state,stateValue
    }}
}`;
}

function getAddOrderToTicketQuery(ticket, menuItem, quantity = 1) {
    var { totalAmount, remainingAmount, ...ticket2 } = ticket;
    var ticketStr = JSON.stringify(ticket2);
    ticketStr = ticketStr.replace(/\"([^(\")"]+)\":/g, '$1:');

    return `
mutation m{ticket:addOrderToTicket(
  ticket:${ticketStr},menuItem:"${menuItem}",quantity:${quantity}
){id,uid,type,number,date,totalAmount,remainingAmount,
  states{stateName,state},
	orders{
    id,
    uid,
    name,
    quantity,
    portion,
    price,
    calculatePrice,
    increaseInventory, 
    decreaseInventory,
    tags{
      tag,tagName,price,quantity,rate,userId
    },
    states{
      stateName,state,stateValue
    }}
}}`;
}

function getPostBroadcastMessageScript(msg) {
    msg = msg.replace(/"/g, '\\"');
    return 'mutation m {postBroadcastMessage(message:"' + msg + '"){message}}';
}



// WEBPACK FOOTER //
// ./app/queries.js